import { Component, Input } from '@angular/core';
import { User } from 'src/app/core/contracts/models/user.model';
import { DEFAULT_AVATAR } from 'src/app/core/utils/constants';
import { environment } from 'src/environments/environment';

const DEFAULT_USERNAME = 'Agente de Prensa';

@Component({
    selector: 'adp-sidebar-avatar',
    templateUrl: './sidebar-avatar.component.html',
})
export class SidebarAvatarComponent {

    @Input() image?: (User & { photoPath?: string | Blob | null }) | null;

    public defaultImage = './assets/images/default-avatar.png';

    public username: string = DEFAULT_USERNAME;

    @Input() set label(label: string | undefined) {
        label
            ? this.username = label
            : this.username = DEFAULT_USERNAME;
    }

    get hasExternalPhoto(): boolean {
        return typeof this.image?.photo === 'string' && this.image.photo.startsWith('http');
    }

    get processedImage(): string {
        const p = this.image?.photo;
        return this.hasExternalPhoto? p as string: p instanceof Blob ? URL.createObjectURL(p): this.defaultImage;
    }
}
